function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.31 90.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.55,6.16h-69a4.54,4.54,0,0,0-4.48,4.59V41.8a1.75,1.75,0,1,0,3.49,0v-31a1,1,0,0,1,1-1h69a1,1,0,0,1,1,1v69.5a1,1,0,0,1-1,1h-69a1,1,0,0,1-1-1V56a3.37,3.37,0,0,0-1.75-6.19A3.37,3.37,0,0,0,7.11,56v24.3a4.54,4.54,0,0,0,4.48,4.59h69A4.54,4.54,0,0,0,85,80.25V10.75A4.54,4.54,0,0,0,80.55,6.16Z",
    style: {
      fill: "#006098"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.8,54.31v2.08a7.75,7.75,0,0,1-.57,3,8.48,8.48,0,0,1-1.59,2.48,7.75,7.75,0,0,1-2.37,1.72,6.78,6.78,0,0,1-2.93.64,10.37,10.37,0,0,1-2.72-.38,6.38,6.38,0,0,1-2.49-1.32,7.46,7.46,0,0,1-1.82-2.43,8.93,8.93,0,0,1-.71-3.81V37.73a8.33,8.33,0,0,1,.55-3.07,7.25,7.25,0,0,1,1.57-2.46,7.32,7.32,0,0,1,2.42-1.63A8,8,0,0,1,28.25,30a7,7,0,0,1,5.39,2.22,8.12,8.12,0,0,1,1.59,2.58A9,9,0,0,1,35.8,38V39.9H31.1V38.29a4,4,0,0,0-.78-2.45,2.52,2.52,0,0,0-2.12-1,2.38,2.38,0,0,0-2.33,1.11,6.14,6.14,0,0,0-.57,2.81V55.91a4.58,4.58,0,0,0,.62,2.46,2.44,2.44,0,0,0,2.24,1,3.39,3.39,0,0,0,1-.16,2.87,2.87,0,0,0,1-.55,3,3,0,0,0,.69-1A4.38,4.38,0,0,0,31.1,56V54.31Z",
    style: {
      fill: "#0075c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.36,63.9l7.32-33.63H47.6L54.93,63.9h-4.7l-1.39-7.23h-6.4L41.06,63.9ZM48,52.13,45.66,40h-.09l-2.3,12.18Z",
    style: {
      fill: "#0075c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.39,44.06V36h3.69v8.06h7.81v3.78H67.08V55.9H63.39V47.84H55.58V44.06Z",
    style: {
      fill: "#0075c9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaIcon);
export default __webpack_public_path__ + "static/media/caIcon.12a6975d.svg";
export { ForwardRef as ReactComponent };